import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isloading } from "../redux/reducer/LoadingReducer";
import axios from "axios";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";
import BaseUrl from "../../base-api";
import { useLocation } from "react-router-dom";

const DirectoryOfficers = () => {
  const location = useLocation();
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AxiosInstance.post(
          `${BaseUrl}/api/officersDirectory/web/getAll`,
          { location: "All" }
        );

        if (res.data.status === 200) {
          setImages(res.data.data);
        } else {
          console.error(res.data.message || "Failed to load images.");
        }
      } catch (error) {
        handleAxiosError(error);
      } finally {
        dispatch(isloading(false));
      }
    };

    if (location.pathname) fetchData();
  }, [location.pathname]);

  useEffect(() => {
    dispatch(isloading(true));
  }, []);
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>A Directory of Officers And Employees</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <p>A directory of its officers and employees.</p>

        <p>
          List of the Officers/Officials of Haryana Seeds Dev. Corpn. Limited as
          on December, 2023
        </p>
       {Object.entries(images).map(([district, officers]) => (
  <div key={district}>
    <h6>{district.toUpperCase()}</h6>

    <div className="table-responsive mb-4">
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th rowSpan="2">S. No.</th>
            <th rowSpan="2">
              Name of the Officer/Official
              <br />
              (S/Shri/Ms.)
            </th>
            <th rowSpan="2">Designation</th>
            <th rowSpan="2">Residential Address</th>
            <th colSpan="2" className="text-center">Telephone No.</th>
          </tr>
          <tr>
            <th>Office</th>
            <th>Residence </th>
          </tr>
        </thead>
        <tbody>
          {officers.map((person, index) => (
            <tr key={person.key || index}>
              <td>{index + 1}</td>
              <td>{person.name || "-"}</td>
              <td>{person.designation || "-"}</td>
              <td>{person.address || "-"}</td>
              <td>{person.officeNo || "-"}</td>
              <td>{person.mobileNo || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
))}


        <p>
          Above lists are subject to change on promotion, transfer and
          retirement.
        </p>

        <p>Sale-counter wise list of employees is available at website.</p>
      </div>
    </div>
  );
};

export default DirectoryOfficers;
